document.addEventListener('DOMContentLoaded', function() {
  const showMoreButtons = document.querySelectorAll('.show-more-btn');
  
  showMoreButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault(); // Empêcher le comportement par défaut du lien
      
      const sectionId = this.dataset.sectionId;
      const visible = parseInt(this.dataset.visible);
      const increment = parseInt(this.dataset.increment);
      const total = parseInt(this.dataset.total);
      
      const grid = document.getElementById(`text-columns-grid-${sectionId}`);
      const items = grid.querySelectorAll('.text-column-item');
      
      // Afficher les prochains éléments
      const newVisible = Math.min(visible + increment, total);
      
      for (let i = visible; i < newVisible; i++) {
        if (items[i]) {
          items[i].style.display = '';
        }
      }
      
      // Mettre à jour le compteur visible
      this.dataset.visible = newVisible;
      
      // Cacher le bouton si tous les éléments sont visibles
      if (newVisible >= total) {
        this.style.display = 'none';
      }
    });
  });
});